<template>
    <div class="price-wrapper mb-2">
        <div class="display-4 float-right">
            <small>From:</small> {{ currency(activity.price.currencyCode) }}{{ formatPrice(activity.price.amount) }}
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: 'ActivityPrice',
        props: {
            activity: {
                type: Object,
                required: true
            },
        },
        methods: {
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            dateDifference(date1, date2) {
                var a = dayjs(date2, "YYYY-MM-DD");
                var b = dayjs(date1, "YYYY-MM-DD");
                return a.diff(b, 'days');
            },
            currency(iso) {
                if (iso == 'EUR') {
                    return '€';
                }
            },
        }
    }
</script>

<style scoped>

</style>